<form>
  <div class="d-flex align-items-center w-100" style="gap: 8px">
    <input [formControl] bfValidationStatus class="form-control" [formControl]="input" nbInput
    [ngClass]="cssClasses" [attr.type]="type" [attr.maxlength]="maxLength || null" (keyup.enter)="onKeyEnter($event)"  (focus)="onTouched()"  (change)="onChange()" style="max-width: 100%"/>
    <button type="button" nbButton status="primary" class="ml-2" (click)="onAddClick()">Agregar</button>
  </div>
  <small *ngIf="maxLength" class="text-muted d-block mt-1" style="font-size:11px">
    Máximo {{ maxLength }} caracteres por opción.
  </small>
  <small *ngIf="lengthError" class="text-danger d-block mt-1" style="font-size:12px">
    La opción ingresada supera el máximo de {{ maxLength }} caracteres permitidos.
  </small>
</form>
<div class="d-flex flex-wrap mt-2 tags-list" *ngIf="tags.length">
    <div *ngFor="let tag of tags" class="bg-primary p-2 mr-2 tag-item d-flex align-items-center">
        <span class="tag-text" style="color: white;">{{ tag }}</span>
        <button type="button" class="close ml-2 tag-close" aria-label="Close" (click)="deleteTag(tag)">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</div>
